import Snackbar from '@components/v2/ui/Snackbar/Snackbar';
import { useTeceoSnackbar } from './hooks/useTeceoSnackbar';

const TeceoSnackbar = () => {
  const { open, notice, close } = useTeceoSnackbar();

  return (
    <Snackbar
      open={open}
      type={notice.type}
      title={notice.title}
      message={notice.message}
      loading={notice.loading}
      onClose={close}
    />
  );
};

export default TeceoSnackbar;
